export interface IAppReportTaskTypeTitlePageData {
    timeSpan: string;
    logo: string;
}

export class AppReportTaskTypeTitlePageData implements IAppReportTaskTypeTitlePageData {
    timeSpan: string;
    logo: string;

    constructor();
    constructor(obj: IAppReportTaskTypeTitlePageData);
    constructor(obj?: any) {
        this.timeSpan = obj && obj.timeSpan || "";
        this.logo = obj && obj.logo || "";
    }
}